// @ts-check
import React from 'react';
import { useContext } from "react";
import ContentPageContext from "@/src/cms/context/ContentPageContext";
import Head from '@/src/shared/components/Head';

export default function ContentHead() {
  const value = useContext(ContentPageContext);

  if (!value) {
    throw new Error('ContentHead must be wrapped with ContentPageContext.Provider or ContentPageContextProvider')
  }

  const { meta, canonicalHREF } = value;

  return <Head title={meta.title} description={meta.description}>
    {canonicalHREF && <link rel="canonical" href={canonicalHREF} />}
  </Head>
}